
import FormGraficoPizza from './graficos/Pizza.js';
import GraficoBarrasSemana from './graficos/GraficoBarrasSemana.js';
import GraficoBarrasMes from './graficos/GraficoBarrasMes.js';
import GraficoFrentes from "./graficos/GraficoBarrasFrentes.js";
import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h2`
  color: #4CAF50;
`;

const Button = styled.button`
  background: #4CAF50;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: 0.3s;

  &:hover {
    background: #388E3C;
  }
`;

const GridGraficos = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 30px;
`;



const LoadingMessage = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: #555;
  text-align: center;
  margin: 30px;

  &::after {
    content: '';
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-left: 10px;
    border: 2px solid #ccc;
    border-top: 2px solid #007bff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    vertical-align: middle;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const DashboardGraficos = ({ pizza, semana, mes, isLoading, frentes }) => {


  //===========================TELA CHEIA==============================//
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.log(`Error attempting to enable full - screen mode: ${err.message}(${err.name})`);
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  return (
    <Container>
      <Header>
        <Title>Gráficos</Title>
        <Button onClick={toggleFullscreen}>Tela Cheia</Button>
      </Header>

      {isLoading ? (
        <LoadingMessage>Carregando dados, por favor aguarde...</LoadingMessage>
      ) : (
        <>
          <GridGraficos>
            <FormGraficoPizza dados={pizza} />
            <GraficoBarrasSemana dados={semana} />
            <GraficoBarrasMes dados={mes} />
          </GridGraficos>
          <GraficoFrentes frentes={frentes} />
        </>
      )}
    </Container>
  );
};

export default DashboardGraficos;
